RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _, CompareData) {

    'use strict';

    views.SocialChannels = Marionette.CollectionView.extend({
        childView: views.SocialChannel,
        className: 'row',
        colWidth: 3,

        collectionEvents: {
            'change:finderFlag': 'updateFinderFlags'
        },

        childViewOptions: function (model) {
            const me = this;

            return {
                companyModel: me.model,
                collection: model.get('handles')
            };
        },

        updateFinderFlags: function (model) {
            const me = this;

            const finderFlags = me.model.get('finderFlags');
            finderFlags[model.get('id')] = model.get('finderFlag');
            me.model.set({
                finderFlags: finderFlags
            });
        }

    });

    _.extend(views.SocialChannels.prototype, RivalIQ.views.rowNormalizer);
}, RivalIQ.data.CompareData);
